import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import api from "@/lib/api";
import { Mail, ArrowRight, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      // API responds 200 even for unknown emails to avoid enumeration.
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-md animate-fade-in">
        <div className="mb-10 text-center">
          <div className="font-display text-5xl leading-none text-stone-900">progres.</div>
        </div>
        {sent ? (
          <div className="card-soft p-8 text-center" data-testid="forgot-sent">
            <div className="w-14 h-14 rounded-2xl bg-stone-900 mx-auto flex items-center justify-center mb-5">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <h1 className="font-display text-2xl text-stone-900 mb-2 leading-tight">
              {t("register.checkInbox")}
            </h1>
            <p className="text-sm text-stone-500 mb-6 leading-relaxed">
              <Trans
                i18nKey="forgot.sentBody"
                values={{ email }}
                components={{ b: <strong /> }}
              />
            </p>
            <Link to="/login" data-testid="forgot-back-login" className="btn-pill inline-flex">
              <ArrowLeft className="w-3.5 h-3.5" />
              {t("auth.backToLogin")}
            </Link>
          </div>
        ) : (
          <div className="card-soft p-8">
            <h1 className="font-display text-3xl text-stone-900 mb-2 leading-tight">
              {t("forgot.title")}
            </h1>
            <p className="text-sm text-stone-500 mb-8">
              {t("forgot.subtitle")}
            </p>
            <form onSubmit={onSubmit} className="space-y-5">
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full bg-white border border-stone-200 rounded-xl px-4 py-3 text-sm focus:outline-none"
              />
              <button
                type="submit"
                data-testid="forgot-submit"
                disabled={busy}
                className="btn-pill w-full disabled:opacity-50"
              >
                {busy ? t("forgot.busy") : t("auth.sendResetLink")}
                <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            <div className="mt-6 text-center text-sm text-stone-500">
              {t("forgot.remember")}{" "}
              <Link to="/login" data-testid="forgot-back-login-inline" className="text-stone-900 font-semibold hover:underline underline-offset-4">
                {t("auth.loginBtn")}
              </Link>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
